import { memo } from 'react';
import {
  useSelector,
  selectTokenIconLarge,
  selectTokenIconSmall,
} from '@bonanza-social/toolkit/state';
import { PrizeWallTokenIconProps } from './PrizeWallTokenIcon.types';
import PrizeWallImage from '../common/PrizeWallImage/PrizeWallImage';

function PrizeWallTokenIcon({
  variant = 'large',
  ...rest
}: PrizeWallTokenIconProps) {
  const tokenIcon = useSelector(
    variant === 'small' ? selectTokenIconSmall : selectTokenIconLarge,
  );

  return <PrizeWallImage {...rest} {...tokenIcon} />;
}

export default memo(PrizeWallTokenIcon);
